import { getTimezoneOffset } from 'date-fns-tz';

export const parseDateCreating = (date: Date, currentTimezone: string) => {
	const timezone = date.getTimezoneOffset() * 60000;

	const localTimezone = getTimezoneOffset(currentTimezone);

	return new Date(date.getTime() - localTimezone - timezone);
};
